import React, { useState, useEffect } from "react";

import { Skeleton, Typography } from "@mui/material";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";

const CONTRACT_SIGNED = "/solutions/green-energy-signed";

export const ContractDetails = ({ history, location }) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const handler = ({ data }) => {
      if (data === "done") {
        history.push(CONTRACT_SIGNED);
      }
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
    // we don't want exhaustive deps here
    // eslint-disable-next-line
  }, []);

  return (
    <SolutionsFrame
      title="Contrato de energia verde"
      currentStep={4}
      totalSteps={6}
    >
      <BlockStandard hideDivider>
        <Typography variant="h2">Termo de adesão</Typography>
      </BlockStandard>

      <BlockStandard hideDivider>
        <iframe
          src={location.state?.envelopeData?.signUrl}
          onLoad={() => setIsLoading(false)}
          title="Docusign - Contrato de energia verde"
          style={{
            width: "100%",
            height: "65vh",
            border: "none",
          }}
        />
      </BlockStandard>

      {isLoading && (
        <Skeleton
          variant="rectangular"
          width="60%"
          height="25%"
          sx={{ position: "absolute", top: "20%", left: "20%" }}
        />
      )}
    </SolutionsFrame>
  );
};
